import type { FC, CSSProperties } from "react";

import type { CSSObject } from "styled-components";
import styled from "styled-components";

import type { TextProps } from "@similarweb/ui-components/foundations";
import { Text } from "@similarweb/ui-components/foundations";

import { useMarkdownProcessor } from "./useMarkdownProcessor";

const StyledText = styled(Text)<{
    isRtl?: boolean;
}>`
    display: block;
    ${({ isRtl }) =>
        isRtl !== undefined &&
        `
        direction: ${isRtl ? "rtl" : "ltr"};
        text-align: ${isRtl ? "start" : "left"};
    `}
`;

interface IHighlightedTextProps extends TextProps {
    text: string;
    highlightedPhrase: RegExp | string | string[];
    highlightStyle: CSSProperties | CSSObject | string;
    caseSensitive?: boolean;
    isRtl?: boolean;
}

export const HighlightedText: FC<IHighlightedTextProps> = ({
    text = "",
    highlightedPhrase = "",
    highlightStyle,
    caseSensitive = false,
    isRtl,
    ...textProps
}) => {
    const processedText = useMarkdownProcessor({
        text,
        highlightedPhrase,
        caseSensitive,
    });

    const highlightStyleString = Object.entries(highlightStyle as CSSProperties)
        .map(([key, value]) => {
            const cssKey = key.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`);
            return `${cssKey}:${value}`;
        })
        .join(";");

    return (
        <>
            {highlightedPhrase ? <style>{`.sw-highlight-marker { ${highlightStyleString} }`}</style> : null}
            <StyledText
                {...textProps}
                style={textProps.style}
                isRtl={isRtl}
                dangerouslySetInnerHTML={{ __html: processedText }}
            />
        </>
    );
};
